import { connect } from 'react-redux';
import Login from './Login';
import { loginRequest, loginFromModalRequest } from '../../redux/actions/login';
const mapStateToProps = state => ({});

const mapDispatchToProps = {
  loginRequest,
  loginFromModalRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);
